// src/api/client.ts
import axios, { AxiosHeaders } from "axios";

/** Rozhodnutí podle prostředí (dev vs. prod) */
function getBaseURL(): string {
  // Jsme v localhost dev režimu? -> nepoužívej PHP proxy
  const isLocal =
    typeof window !== "undefined" &&
    /^(localhost|127\.0\.0\.1|\[::1\])$/i.test(window.location.hostname);

  // CRA používá REACT_APP_*, ale pro jistotu bereme i Vite/API_URL
  const fromEnv =
    (typeof process !== "undefined" &&
      (process as any).env &&
      (
        (process as any).env.REACT_APP_API_URL ||
        (process as any).env.VITE_API_URL ||
        (process as any).env.API_URL
      )) ||
    undefined;

  // Produkční hodnota může přijít z window.__API_URL__ (PHP šablona / .htaccess)
  const fromWindow =
    typeof window !== "undefined" ? (window as any).__API_URL__ : undefined;

  // Lokálně preferuj env, v produkci preferuj window.__API_URL__
  const chosen = isLocal ? (fromEnv || "") : (fromWindow || fromEnv || "");

  // Fallback, pokud nic nenajdeme
  return chosen || "http://10.10.0.65:4000";
}

/** Pokud je to PHP proxy, přepni do query režimu ?path= */
function normalizeBase(url: string) {
  if (/api-proxy\.php\?/.test(url)) return url;                 // už obsahuje ?path=
  if (/api-proxy\.php\/?$/.test(url)) return url.replace(/\/?$/, "") + "?path=";
  return url.replace(/\/+$/, "");                               // jinak ořízni trailing /
}

const api = axios.create({
  baseURL: normalizeBase(getBaseURL()),
  withCredentials: true,
});

// nasadit Authorization z localStorage (pokud existuje)
try {
  const t = localStorage.getItem("auth.token");
  if (t) (api.defaults.headers as any).common["Authorization"] = `Bearer ${t}`;
} catch {}

/** ✅ GET cache-buster + typově korektní nastavení hlaviček */
api.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();
  if (method === "get") {
    // query cache-buster
    config.params = { ...(config.params as any), _ts: Date.now() };

    // hlavičky: podporuj Axios v1 (AxiosHeaders) i plain object
    let h = config.headers;
    if (!h) h = new AxiosHeaders();
    if (h instanceof AxiosHeaders) {
      h.set("Cache-Control", "no-cache");
    } else {
      (h as Record<string, any>)["Cache-Control"] = "no-cache";
    }
    config.headers = h;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const msg = String(err?.response?.data?.error || "").toLowerCase();
    if (
      err?.response?.status === 401 &&
      (msg.includes("invalid token") || msg.includes("jwt"))
    ) {
      try { localStorage.removeItem("auth.token"); } catch {}
      if ((api.defaults.headers as any)?.common) {
        delete (api.defaults.headers as any).common["Authorization"];
      }
    }
    return Promise.reject(err);
  }
);

export default api;
